import { FormControl, FormLabel, Input, FormErrorMessage, Tooltip, useColorModeValue } from '@chakra-ui/react';
import { useSelector } from 'react-redux';

const NameField = ({ value, onChange, error }) => {
  const labelColor = useColorModeValue('black', 'white');
   const { darkMode } = useSelector((state) => state.settings);
  return (
    <FormControl isInvalid={!!error} isRequired>
      <Tooltip label="Enter a name for this rate." placement="top">
        <FormLabel color={darkMode ? 'white' : 'black'}>Name</FormLabel>
      </Tooltip>
      <Input
        name="name"
        value={value}
        onChange={onChange}
        placeholder="Name"
        style={{
                 background: darkMode ? '#1e2021' : 'white',
                 color: `${darkMode ? '#f5f4f3' : 'inherit'}`,
          borderColor: `${darkMode ? '#565557' : '#007bff'}`
               }}
      />
      {error && <FormErrorMessage>{error}</FormErrorMessage>}
    </FormControl>
  );
};

export default NameField;
